import { Link } from "react-router-dom";
import type { Article } from "@/mocks/articles";
import { formatDate } from "@/lib/content";

type ArticleItemProps = {
  article: Article;
  index?: number;
};

export default function ArticleItem({ article, index }: ArticleItemProps) {
  return (
    <Link
      to={`/special?article=${article.id}`}
      className="group flex gap-4 p-3 md:p-4 rounded-lg hover:bg-background-100 transition-colors cursor-pointer"
    >
      {typeof index === "number" ? (
        <span
          className={`font-label text-lg md:text-xl font-semibold shrink-0 w-8 text-center ${
            index < 3 ? "text-accent-500" : "text-foreground-300"
          }`}
        >
          {String(index + 1).padStart(2, "0")}
        </span>
      ) : (
        <span className="w-24 h-16 md:w-28 md:h-[72px] rounded-md overflow-hidden shrink-0 bg-foreground-900">
          <img
            src={article.cover}
            alt={article.title}
            title={article.title}
            className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
          />
        </span>
      )}
      <div className="min-w-0 flex-1">
        <h3 className="font-medium text-sm md:text-base text-foreground-950 group-hover:text-primary-600 transition-colors line-clamp-2">
          {article.title}
        </h3>
        <p className="mt-1.5 text-xs md:text-sm text-foreground-500 line-clamp-2">
          {article.summary}
        </p>
        <div className="mt-2 flex items-center gap-3 text-xs text-foreground-400">
          <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full bg-secondary-100 text-secondary-900">
            {article.category}
          </span>
          <span className="flex items-center gap-1">
            <i className="ri-calendar-line"></i>
            {formatDate(article.date)}
          </span>
        </div>
      </div>
    </Link>
  );
}